import img1 from '../assets/images/product1.png'
import img2 from '../assets/images/product2.png'
import img3 from '../assets/images/product3.png'
import img4 from '../assets/images/product4.png'
import img5 from '../assets/images/product5.png'
import img6 from '../assets/images/product6.png'
import img7 from '../assets/images/product7.png'
import img8 from '../assets/images/product8.png'
import img9 from '../assets/images/product9.png'
import img10 from '../assets/images/product10.png'
import img11 from '../assets/images/product11.png'
import img12 from '../assets/images/product12.png'
import img13 from '../assets/images/product13.png'
import img14 from '../assets/images/product14.png'
import img15 from '../assets/images/product5.png'
import img16 from '../assets/images/product6.png'

export const productData = [
    {
       id:1,
       name: 'Carrots Group Scal',
       image: img1,
       rating: 4.5,
       brand: "Zara",
       offer: "new",
       color1:'black',
       price: 32,
       delprice: 37,
       product: "top",
    },
    {
        id:2,
        name: 'Carrots Group Scal',
        image: img2,
        rating: 4.5,
        brand: "Zara",
        offer: "new",
        color1:'black',
        price: 32,
        delprice: 37,
        product: "top",
     },
     {
        id:3,
        name: 'Orange fresh juice',
        image: img3,
        rating: 4.5,
        brand: "Zara",
        offer: "new",
        color1:'mixed',
        price: 75,
        delprice: 80,
        product: "top",
     },
     {
        id:4,
        name: 'Poltry farm meat',
        image: img4,
        rating: 4,
        brand: "Zara",
        offer: "new",
        color1:'mixed',
        price: 40,
        delprice: 50,
        product: "top",
     },
     {
        id:5,
        name: 'Orange fresh juice',
        image: img5,
        rating: 4.5,
        brand: "Zara",
        offer: "new",
        color1:'mixed',
        price: 34,
        delprice: 37,
        product: "top",
     },
     {
        id:6,
        name: 'Orange sliced mix',
        image: img6,
        rating: 4.5,
        brand: "Zara",
        offer: "new",
        color1:'gray',
        price: 180,
        delprice: 200,
        product: "top",
     },
     {
        id:7,
        name: 'Carrots Group Scal',
        image: img7,
        rating: 3.5,
        brand: "Zara",
        offer: "new",
        color1:'mixed',
        price: 32,
        delprice: 35,
        product: "top",
     },
     {
        id:8,
        name: 'Orange fresh juice',
        image: img8,
        rating: 4.5,
        brand: "Zara",
        offer: "new",
        color1:'black',
        price: 72,
        delprice: 76,
        product: "top",
     },
     {
      id:9,
      name: 'Carrots Group Scal',
      image: img9,
      rating: 4.5,
      brand: "Zara",
      offer: "new",
      color1:'black',
      price: 32,
      delprice: 37,
      product: "featured",
   },
   {
       id:10,
       name: 'Carrots Group Scal',
       image: img10,
       rating: 4.5,
       brand: "Zara",
       offer: "new",
       color1:'black',
       price: 32,
       delprice: 37,
       product: "featured",
    },
    {
       id:11,
       name: 'Orange fresh juice',
       image: img11,
       rating: 4.5,
       brand: "Zara",
       offer: "new",
       color1:'mixed',
       price: 75,
       delprice: 80,
       product: "featured",
    },
    {
       id:12,
       name: 'Poltry farm meat',
       image: img12,
       rating: 4,
       brand: "Zara",
       offer: "new",
       color1:'mixed',
       price: 40,
       delprice: 50,
       product: "featured",
    },
    {
       id:13,
       name: 'Orange fresh juice',
       image: img13,
       rating: 4.5,
       brand: "Zara",
       offer: "new",
       color1:'mixed',
       price: 34,
       delprice: 37,
       product: "featured",
    },
    {
       id:14,
       name: 'Orange sliced mix',
       image: img14,
       rating: 4.5,
       brand: "Zara",
       offer: "new",
       color1:'gray',
       price: 180,
       delprice: 200,
       product: "featured",
    },
    {
       id:15,
       name: 'Carrots Group Scal',
       image: img15,
       rating: 3.5,
       brand: "Zara",
       offer: "new",
       color1:'mixed',
       price: 32,
       delprice: 35,
       product: "featured",
    },
    {
       id:16,
       name: 'Orange fresh juice',
       image: img16,
       rating: 4.5,
       brand: "Zara",
       offer: "new",
       color1:'black',
       price: 72,
       delprice: 76,
       product: "featured",
    },
   
]